var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import styled from 'styled-components';
import { Box } from 'pcln-design-system';
export var ErrorImgWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "ErrorComponentstyles__ErrorImgWrapper",
  componentId: "sc-1c1e3gp-0"
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  z-index: 1;\n"], ["\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  z-index: 1;\n"])));
export var ErrorTextWrapper = /*#__PURE__*/styled(Box).withConfig({
  displayName: "ErrorComponentstyles__ErrorTextWrapper",
  componentId: "sc-1c1e3gp-1"
})(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  position: absolute;\n  bottom: 20px;\n  left: 0;\n  right: 0;\n  box-sizing: border-box;\n  z-index: 1;\n  span {\n    font-weight: bold;\n  }\n"], ["\n  position: absolute;\n  bottom: 20px;\n  left: 0;\n  right: 0;\n  box-sizing: border-box;\n  z-index: 1;\n  span {\n    font-weight: bold;\n  }\n"])));
var templateObject_1, templateObject_2;